/* HDZBOLD · advertorial behaviour: offer tiers (ladder or v2 buy box), hand picker, add to cart, sticky bar, lazy video. */
(function () {
  if (window.__hdzAdv) return; window.__hdzAdv = true;

  /* ---------- videos: play only while on screen ---------- */
  function start(v) {
    if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; v.load(); }
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () {
      v.addEventListener('canplay', function h() { v.removeEventListener('canplay', h); v.play().catch(function () {}); });
    });
  }
  function wireVideos() {
    var vids = document.querySelectorAll('.hdza video[data-hdza-auto]');
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) start(v);
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- smooth anchors ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1); if (!id) return;
    var t = document.getElementById(id); if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- offer ---------- */
  function wireOffer(root) {
    var tiers = root.querySelectorAll('[data-tier]');
    var hands = root.querySelectorAll('[data-hand]');
    var btn = root.querySelector('[data-hdza-add]');
    var err = root.querySelector('[data-hdza-err]');
    var R = root.dataset.right, L = root.dataset.left, ROD = root.dataset.rod;

    function sel(list) { for (var i = 0; i < list.length; i++) if (list[i].classList.contains('is-on')) return list[i]; return list[0]; }
    function pick(list, el) { list.forEach(function (x) { x.classList.toggle('is-on', x === el); x.setAttribute('aria-checked', x === el ? 'true' : 'false'); }); }
    function refresh() {
      var t = sel(tiers);
      if (btn && t) btn.innerHTML = t.dataset.cta + ' <span aria-hidden="true">→</span>';
      document.querySelectorAll('[data-hdza-sticky-price]').forEach(function (s) { s.textContent = t.dataset.label; });
    }
    /* the picture follows the tier: reels / reels + rod / four reels */
    var mainImg = root.querySelector('.hdza-offer__img img');
    var ribbon = root.querySelector('[data-hdza-ribbon]');
    var firstThumb = root.querySelector('.hdza-thumb');
    function showTier(t) {
      if (mainImg && t.dataset.img) {
        mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = t.dataset.img;
        if (firstThumb) {
          firstThumb.dataset.full = t.dataset.img;
          var ti = firstThumb.querySelector('img'); if (ti && t.dataset.thumb) { ti.removeAttribute('srcset'); ti.src = t.dataset.thumb; }
          root.querySelectorAll('.hdza-thumb').forEach(function (x) { x.classList.toggle('is-on', x === firstThumb); });
        }
      }
      if (ribbon && t.dataset.ribbon) ribbon.textContent = t.dataset.ribbon;
    }
    tiers.forEach(function (t) { t.addEventListener('click', function () { pick(tiers, t); refresh(); showTier(t); }); });
    hands.forEach(function (h) { h.addEventListener('click', function () { pick(hands, h); }); });
    refresh();

    function items() {
      var t = sel(tiers), h = sel(hands).dataset.hand;
      var reels = parseInt(t.dataset.reels, 10) || 2, rod = t.dataset.rod === '1';
      var list = [];
      if (h === 'mix') {
        var half = reels / 2;
        list.push({ id: Number(R), quantity: half });
        list.push({ id: Number(L || R), quantity: half });
      } else {
        list.push({ id: Number(h === 'left' ? (L || R) : R), quantity: reels });
      }
      if (rod && ROD) list.push({ id: Number(ROD), quantity: 1 });
      return list;
    }

    if (!btn) return;
    btn.addEventListener('click', function () {
      if (btn.dataset.busy) return;
      if (!R) { window.location.href = btn.dataset.fallback || '/collections/all'; return; }
      btn.dataset.busy = '1'; btn.style.opacity = '.75'; if (err) err.style.display = 'none';
      addItems(items()).then(openCart)
        .catch(function () { if (err) err.style.display = 'block'; })
        .finally(function () { btn.dataset.busy = ''; btn.style.opacity = ''; });
    });
  }

  function addItems(list) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: list })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function openCart() {
    if (window.bogoCart && window.bogoCart.refresh) {
      window.bogoCart.refresh();
      window.bogoCart.openWhenReady(function () { window.location.href = '/cart'; });
    } else if (typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function') {
      window.upcartRefreshCart(); window.upcartOpenCart();
    } else {
      window.location.href = '/cart';
    }
  }

  /* ---------- offer · layout v2: a hand per reel (paid / free), 1 or 2 pairs, add-on rows ---------- */
  /* UpCart opens its drawer on every /cart/add.js unless upcartShouldSkipAddToCart returns true, so the
     add-on rows raise a flag only for their own add (same hook as the v2 landing); the main button opens it. */
  var silent = false;
  function armSilent() {
    var prev = window.upcartShouldSkipAddToCart;
    if (prev && prev.__hdza) return;
    var fn = function (e) { if (silent) return true; return typeof prev === 'function' ? prev(e) : false; };
    fn.__hdza = true;
    window.upcartShouldSkipAddToCart = fn;
  }

  function wireV2(root) {
    var R = root.dataset.right, L = root.dataset.left || root.dataset.right;
    var tiers = root.querySelectorAll('[data-v2-tier]');
    var btn = root.querySelector('[data-v2-add]');
    var err = root.querySelector('[data-hdza-err]');
    var priceEl = root.querySelector('[data-v2-price]'), cmpEl = root.querySelector('[data-v2-compare]'), saveEl = root.querySelector('[data-v2-save]');
    var mainImg = root.querySelector('.hdza-offer__img img'), ribbon = root.querySelector('[data-hdza-ribbon]'), firstThumb = root.querySelector('.hdza-thumb');
    var qty = 1, withRod = false, ROD = root.dataset.rod;

    function pick(list, el) { list.forEach(function (x) { var on = x === el; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
    function hand(g) { var on = root.querySelector('[data-v2-hand="' + g + '"].is-on'); return on ? on.dataset.val : 'right'; }
    function sticky(t) { document.querySelectorAll('[data-hdza-sticky-price]').forEach(function (s) { s.textContent = t.dataset.label; }); }

    root.querySelectorAll('[data-v2-hand]').forEach(function (b) {
      b.addEventListener('click', function () { pick(root.querySelectorAll('[data-v2-hand="' + b.dataset.v2Hand + '"]'), b); });
    });
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        pick(tiers, t);
        setTier(t);
        if (mainImg && t.dataset.img) {
          mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = t.dataset.img;
          if (firstThumb) {
            firstThumb.dataset.full = t.dataset.img;
            var ti = firstThumb.querySelector('img'); if (ti && t.dataset.thumb) { ti.removeAttribute('srcset'); ti.src = t.dataset.thumb; }
            root.querySelectorAll('.hdza-thumb').forEach(function (x) { x.classList.toggle('is-on', x === firstThumb); });
          }
        }
        if (ribbon && t.dataset.ribbon) ribbon.textContent = t.dataset.ribbon;
        sticky(t);
      });
    });
    /* tier "s" = one pair + the rod in the same add; its rod row below is hidden */
    function setTier(t) {
      var k = t.dataset.v2Tier;
      qty = k === '2' ? 2 : 1; withRod = k === 's';
      root.classList.toggle('is-setup', withRod);
      if (priceEl) priceEl.textContent = t.dataset.price;
      if (cmpEl && t.dataset.compare) cmpEl.textContent = t.dataset.compare;
      if (saveEl && t.dataset.save) saveEl.textContent = t.dataset.save;
      root.querySelectorAll('[data-v2-hl]').forEach(function (h) { var v = qty > 1 ? h.dataset.many : h.dataset.one; if (v) h.innerHTML = v; });
    }
    var on = root.querySelector('[data-v2-tier].is-on'); if (on) { setTier(on); sticky(on); }

    if (btn) btn.addEventListener('click', function () {
      if (btn.dataset.busy) return;
      if (!R) { window.location.href = btn.dataset.fallback || '/collections/all'; return; }
      var v1 = hand('r1') === 'left' ? L : R, v2 = hand('r2') === 'left' ? L : R;
      var list = v1 === v2 ? [{ id: Number(v1), quantity: qty * 2 }] : [{ id: Number(v1), quantity: qty }, { id: Number(v2), quantity: qty }];
      if (withRod && ROD) list.push({ id: Number(ROD), quantity: 1 });
      btn.dataset.busy = '1'; btn.style.opacity = '.75'; if (err) err.style.display = 'none';
      addItems(list).then(openCart)
        .catch(function () { if (err) err.style.display = 'block'; })
        .finally(function () { btn.dataset.busy = ''; btn.style.opacity = ''; });
    });

    root.querySelectorAll('[data-v2-up]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.busy) return;
        b.dataset.busy = '1'; b.style.opacity = '.6';
        armSilent(); silent = true;
        addItems([{ id: Number(b.dataset.v2Up), quantity: 1 }])
          .then(function () {
            b.classList.add('is-done'); b.textContent = 'Added \u2713';
            if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
          })
          .catch(function () { b.textContent = 'Try again'; })
          .then(function () {
            b.dataset.busy = ''; b.style.opacity = '';
            setTimeout(function () { silent = false; }, 600);
            setTimeout(function () { b.classList.remove('is-done'); b.textContent = b.dataset.label; }, 2600);
          });
      });
    });
  }

  /* ---------- sticky bar: after the hero, hidden while the offer is on screen ---------- */
  function wireSticky() {
    var bar = document.querySelector('[data-hdza-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var wrap = bar.closest('[data-hdza-sticky-wrap]') || bar;
    if (wrap.parentNode !== document.body) document.body.appendChild(wrap);
    var hero = document.querySelector('[data-hdza-hero]');
    var offers = document.querySelectorAll('[data-hdza-offer]');
    var pastHero = false, offerVisible = 0;
    function upd() { bar.classList.toggle('is-on', pastHero && offerVisible === 0); }
    if (hero) new IntersectionObserver(function (es) { es.forEach(function (e) { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; }); upd(); }).observe(hero);
    else pastHero = true;
    var seen = new Map();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      offerVisible = 0; seen.forEach(function (v) { if (v) offerVisible++; }); upd();
    });
    offers.forEach(function (o) { io.observe(o); });
  }

  /* ---------- offer gallery: thumbs swap the main picture ---------- */
  function wireGallery(g) {
    var main = g.querySelector('.hdza-offer__img img');
    var thumbs = g.querySelectorAll('.hdza-thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        main.removeAttribute('srcset'); main.removeAttribute('sizes');
        main.src = t.dataset.full;
        thumbs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
      });
    });
  }

  /* ---------- reading progress ---------- */
  function wireProgress() {
    var bar = document.querySelector('[data-hdza-progress]');
    if (!bar) return;
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var fill = bar.querySelector('[data-hdza-progress-fill]') || bar;
    var ticking = false;
    function upd() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      fill.style.width = (h > 0 ? Math.min(100, (window.scrollY / h) * 100) : 0) + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  function init() {
    wireVideos();
    document.querySelectorAll('[data-hdza-gallery]').forEach(wireGallery);
    wireProgress();
    document.querySelectorAll('[data-hdza-offer]').forEach(function (o) { (o.hasAttribute('data-hdza-v2') ? wireV2 : wireOffer)(o); });
    wireSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
